/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { OperationToJSON, UploadUserFileRequestToJSON, UserIncidentFootageDtoFromJSON, UserIncidentFootageDtoPageResponseFromJSON, UserIncidentFootageMarkerDtoFromJSON, UserIncidentFootageMarkerDtoToJSON, } from '../models/index';
/**
 *
 */
export class CreatorIncidentFootageApi extends runtime.BaseAPI {
    /**
     */
    creatorIncidentFootageCreateFileRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.userProfileId === null || requestParameters.userProfileId === undefined) {
                throw new runtime.RequiredError('userProfileId', 'Required parameter requestParameters.userProfileId was null or undefined when calling creatorIncidentFootageCreateFile.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/users/{userProfileId}/files/incident-footage`.replace(`{${"userProfileId"}}`, encodeURIComponent(String(requestParameters.userProfileId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: UploadUserFileRequestToJSON(requestParameters.uploadUserFileRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => UserIncidentFootageDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    creatorIncidentFootageCreateFile(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.creatorIncidentFootageCreateFileRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    creatorIncidentFootageCreateMarkerByUserProfileIdAndUploadedFileIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.userProfileId === null || requestParameters.userProfileId === undefined) {
                throw new runtime.RequiredError('userProfileId', 'Required parameter requestParameters.userProfileId was null or undefined when calling creatorIncidentFootageCreateMarkerByUserProfileIdAndUploadedFileId.');
            }
            if (requestParameters.uploadedFileId === null || requestParameters.uploadedFileId === undefined) {
                throw new runtime.RequiredError('uploadedFileId', 'Required parameter requestParameters.uploadedFileId was null or undefined when calling creatorIncidentFootageCreateMarkerByUserProfileIdAndUploadedFileId.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/users/{userProfileId}/files/incident-footage/{uploadedFileId}/markers`.replace(`{${"userProfileId"}}`, encodeURIComponent(String(requestParameters.userProfileId))).replace(`{${"uploadedFileId"}}`, encodeURIComponent(String(requestParameters.uploadedFileId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: UserIncidentFootageMarkerDtoToJSON(requestParameters.userIncidentFootageMarkerDto),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => UserIncidentFootageMarkerDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    creatorIncidentFootageCreateMarkerByUserProfileIdAndUploadedFileId(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.creatorIncidentFootageCreateMarkerByUserProfileIdAndUploadedFileIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    creatorIncidentFootageDeleteFileByUploadedFileIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.uploadedFileId === null || requestParameters.uploadedFileId === undefined) {
                throw new runtime.RequiredError('uploadedFileId', 'Required parameter requestParameters.uploadedFileId was null or undefined when calling creatorIncidentFootageDeleteFileByUploadedFileId.');
            }
            if (requestParameters.userProfileId === null || requestParameters.userProfileId === undefined) {
                throw new runtime.RequiredError('userProfileId', 'Required parameter requestParameters.userProfileId was null or undefined when calling creatorIncidentFootageDeleteFileByUploadedFileId.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/users/{userProfileId}/files/incident-footage/{uploadedFileId}`.replace(`{${"uploadedFileId"}}`, encodeURIComponent(String(requestParameters.uploadedFileId))).replace(`{${"userProfileId"}}`, encodeURIComponent(String(requestParameters.userProfileId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    creatorIncidentFootageDeleteFileByUploadedFileId(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.creatorIncidentFootageDeleteFileByUploadedFileIdRaw(requestParameters, initOverrides);
        });
    }
    /**
     */
    creatorIncidentFootageDeleteMarkerByUserProfileIdAndUploadedFileIdAndMarkerIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.userProfileId === null || requestParameters.userProfileId === undefined) {
                throw new runtime.RequiredError('userProfileId', 'Required parameter requestParameters.userProfileId was null or undefined when calling creatorIncidentFootageDeleteMarkerByUserProfileIdAndUploadedFileIdAndMarkerId.');
            }
            if (requestParameters.uploadedFileId === null || requestParameters.uploadedFileId === undefined) {
                throw new runtime.RequiredError('uploadedFileId', 'Required parameter requestParameters.uploadedFileId was null or undefined when calling creatorIncidentFootageDeleteMarkerByUserProfileIdAndUploadedFileIdAndMarkerId.');
            }
            if (requestParameters.markerId === null || requestParameters.markerId === undefined) {
                throw new runtime.RequiredError('markerId', 'Required parameter requestParameters.markerId was null or undefined when calling creatorIncidentFootageDeleteMarkerByUserProfileIdAndUploadedFileIdAndMarkerId.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/users/{userProfileId}/files/incident-footage/{uploadedFileId}/markers/{markerId}`.replace(`{${"userProfileId"}}`, encodeURIComponent(String(requestParameters.userProfileId))).replace(`{${"uploadedFileId"}}`, encodeURIComponent(String(requestParameters.uploadedFileId))).replace(`{${"markerId"}}`, encodeURIComponent(String(requestParameters.markerId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    creatorIncidentFootageDeleteMarkerByUserProfileIdAndUploadedFileIdAndMarkerId(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.creatorIncidentFootageDeleteMarkerByUserProfileIdAndUploadedFileIdAndMarkerIdRaw(requestParameters, initOverrides);
        });
    }
    /**
     */
    creatorIncidentFootageGetFileByUploadedFileIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.uploadedFileId === null || requestParameters.uploadedFileId === undefined) {
                throw new runtime.RequiredError('uploadedFileId', 'Required parameter requestParameters.uploadedFileId was null or undefined when calling creatorIncidentFootageGetFileByUploadedFileId.');
            }
            if (requestParameters.userProfileId === null || requestParameters.userProfileId === undefined) {
                throw new runtime.RequiredError('userProfileId', 'Required parameter requestParameters.userProfileId was null or undefined when calling creatorIncidentFootageGetFileByUploadedFileId.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/users/{userProfileId}/files/incident-footage/{uploadedFileId}`.replace(`{${"uploadedFileId"}}`, encodeURIComponent(String(requestParameters.uploadedFileId))).replace(`{${"userProfileId"}}`, encodeURIComponent(String(requestParameters.userProfileId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => UserIncidentFootageDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    creatorIncidentFootageGetFileByUploadedFileId(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.creatorIncidentFootageGetFileByUploadedFileIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    creatorIncidentFootageListMarkersByUserProfileIdAndUploadedFileIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.userProfileId === null || requestParameters.userProfileId === undefined) {
                throw new runtime.RequiredError('userProfileId', 'Required parameter requestParameters.userProfileId was null or undefined when calling creatorIncidentFootageListMarkersByUserProfileIdAndUploadedFileId.');
            }
            if (requestParameters.uploadedFileId === null || requestParameters.uploadedFileId === undefined) {
                throw new runtime.RequiredError('uploadedFileId', 'Required parameter requestParameters.uploadedFileId was null or undefined when calling creatorIncidentFootageListMarkersByUserProfileIdAndUploadedFileId.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/users/{userProfileId}/files/incident-footage/{uploadedFileId}/markers`.replace(`{${"userProfileId"}}`, encodeURIComponent(String(requestParameters.userProfileId))).replace(`{${"uploadedFileId"}}`, encodeURIComponent(String(requestParameters.uploadedFileId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserIncidentFootageMarkerDtoFromJSON));
        });
    }
    /**
     */
    creatorIncidentFootageListMarkersByUserProfileIdAndUploadedFileId(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.creatorIncidentFootageListMarkersByUserProfileIdAndUploadedFileIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    creatorIncidentFootagePaginateFilesRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.userProfileId === null || requestParameters.userProfileId === undefined) {
                throw new runtime.RequiredError('userProfileId', 'Required parameter requestParameters.userProfileId was null or undefined when calling creatorIncidentFootagePaginateFiles.');
            }
            const queryParameters = {};
            if (requestParameters.page !== undefined) {
                queryParameters['page'] = requestParameters.page;
            }
            if (requestParameters.pageSize !== undefined) {
                queryParameters['pageSize'] = requestParameters.pageSize;
            }
            const headerParameters = {};
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/users/{userProfileId}/files/incident-footage`.replace(`{${"userProfileId"}}`, encodeURIComponent(String(requestParameters.userProfileId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => UserIncidentFootageDtoPageResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    creatorIncidentFootagePaginateFiles(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.creatorIncidentFootagePaginateFilesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    creatorIncidentFootageUpdateMarkerByUserProfileIdAndUploadedFileIdAndMarkerIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.userProfileId === null || requestParameters.userProfileId === undefined) {
                throw new runtime.RequiredError('userProfileId', 'Required parameter requestParameters.userProfileId was null or undefined when calling creatorIncidentFootageUpdateMarkerByUserProfileIdAndUploadedFileIdAndMarkerId.');
            }
            if (requestParameters.uploadedFileId === null || requestParameters.uploadedFileId === undefined) {
                throw new runtime.RequiredError('uploadedFileId', 'Required parameter requestParameters.uploadedFileId was null or undefined when calling creatorIncidentFootageUpdateMarkerByUserProfileIdAndUploadedFileIdAndMarkerId.');
            }
            if (requestParameters.markerId === null || requestParameters.markerId === undefined) {
                throw new runtime.RequiredError('markerId', 'Required parameter requestParameters.markerId was null or undefined when calling creatorIncidentFootageUpdateMarkerByUserProfileIdAndUploadedFileIdAndMarkerId.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json-patch+json';
            if (requestParameters.turnstileToken !== undefined && requestParameters.turnstileToken !== null) {
                headerParameters['Turnstile-Token'] = String(requestParameters.turnstileToken);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("Bearer", []);
            }
            const response = yield this.request({
                path: `/users/{userProfileId}/files/incident-footage/{uploadedFileId}/markers/{markerId}`.replace(`{${"userProfileId"}}`, encodeURIComponent(String(requestParameters.userProfileId))).replace(`{${"uploadedFileId"}}`, encodeURIComponent(String(requestParameters.uploadedFileId))).replace(`{${"markerId"}}`, encodeURIComponent(String(requestParameters.markerId))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.operation.map(OperationToJSON),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => UserIncidentFootageMarkerDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    creatorIncidentFootageUpdateMarkerByUserProfileIdAndUploadedFileIdAndMarkerId(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.creatorIncidentFootageUpdateMarkerByUserProfileIdAndUploadedFileIdAndMarkerIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
